import { ReactElement } from 'react';
import { Skeleton, Select, Empty } from 'antd';
import { useLocation } from 'react-router-dom';
import { ChevronDownOutlined } from 'assets/icons/icons';
import { _isEmpty } from 'app/utils/helpers';
import { kFormatter } from 'app/utils/helpers/kFormatter';
import URL from 'app/constants/route_urls';
import { useRacesWidget } from 'app/hooks/useRacesWidget';
import racesSlice from 'app/store/races/races.slice';
import { useGetWidgetRaces } from 'app/utils/api/queries/races.query';
import { useGetRaceReport } from 'app/utils/api/queries/race_marketer.query';
import 'app/components/modules/race_select/race_select.scss';

/**
 * TODO Conduct better logic with the race Select Widget when the user changes location
 * TODO If current race is empty remove local storage
 */

const RaceSelect = (): ReactElement => {
    const location = useLocation();
    const { data: widgetRaces, isError, isLoading } = useGetWidgetRaces({ display: 'menu' });
    const { currentRace } = racesSlice();

    const { isLoading: reportIsLoading } = useGetRaceReport(
        { pk: currentRace.pk! },
        {
            enabled: false,
        }
    );

    const { handleSelectRaceString } = useRacesWidget();

    const isRaceReport = location.pathname.includes(URL.REPORTS);

    const options = widgetRaces?.map((race) => {
        const value = JSON.parse(race.value || '{}');
        const newValue = {
            pk: value.pk,
            name: value.name,
            type: value.display_group || value.type,
        };

        return {
            label: race.name,
            groupLabel: race.groupLabel,
            value: JSON.stringify(newValue),
        };
    });

    const upcomingOptions = options?.filter((o) => o.groupLabel === 'upcoming');
    const pastOptions = options?.filter((o) => o.groupLabel === 'past');

    // Render Select content
    const renderRaceSelectContent = (): JSX.Element => {
        if (isLoading)
            return <Skeleton paragraph={{ rows: 1, width: '100%' }} title={false} active loading />;

        return (
            <div className='race-select__field navbar-select__item'>
                <Select
                    style={{ width: '100%' }}
                    aria-label='Select race'
                    status={isError ? 'error' : ''}
                    value={currentRace?.name}
                    popupClassName='navbar-select__selector'
                    disabled={_isEmpty(widgetRaces) || (isRaceReport && reportIsLoading)}
                    options={[
                        {
                            label: (
                                <div className='navbar-select__group-label'>
                                    Upcoming{' '}
                                    <span className='navbar-select__group-count'>
                                        {kFormatter(upcomingOptions?.length as number)}
                                    </span>
                                </div>
                            ),
                            title: 'upcoming',
                            options: upcomingOptions,
                        },
                        {
                            label: (
                                <div className='navbar-select__group-label'>
                                    Past{' '}
                                    <span className='navbar-select__group-count'>
                                        {kFormatter(pastOptions?.length as number)}
                                    </span>
                                </div>
                            ),
                            title: 'past',
                            options: pastOptions,
                        },
                    ]}
                    showSearch
                    onChange={(value: string) => handleSelectRaceString(value)}
                    labelInValue={false}
                    notFoundContent={
                        <Empty
                            image={Empty.PRESENTED_IMAGE_DEFAULT}
                            description='No races found'
                        />
                    }
                    suffixIcon={_isEmpty(currentRace.name) ? null : <ChevronDownOutlined />}
                />
            </div>
        );
    };

    return (
        <div className={`race-select ${isLoading ? 'isLoading' : ''}`}>
            {renderRaceSelectContent()}
        </div>
    );
};

export default RaceSelect;
